import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//@ts-expect-error TODO: fix this
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function omit(obj, props, fn) {
  if (_typeof(obj) !== 'object' || !obj || Array.isArray(obj)) return {};
  if (typeof props === 'function') {
    fn = props;
    props = [];
  }
  if (typeof props === 'string') {
    props = [props];
  }
  var isFunction = typeof fn === 'function';
  var keys = Object.keys(obj);
  var res = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];
    if (!props || props.indexOf(key) === -1 && (!isFunction || fn(val, key, obj))) {
      //@ts-expect-error TODO: fix this
      res[key] = val;
    }
  }
  return res;
}